import axios from "axios";
import { endpoint, multipartAuthConfig } from "./http";

export async function searchListingsByImage({ accessToken, apiUrl, image }) {
  const formData = new FormData();
  formData.append("image", image);

  const response = await axios.post(
    endpoint(apiUrl, "/search/image"),
    formData,
    multipartAuthConfig(accessToken),
  );

  return response.data.results || [];
}
